export default {
  cn: {
    home: {
      title: "高效 迅捷 周全",
      subTitle: "一站式外贸综合服务平台",
      subTitle2: "国际物流与货运代理综合解决方案",
      stop: "一站式服务解决方案",
      team: "资深团队，价格实惠",
      more: "更多详情",
      us: "了解我们",
      transport: "外贸综合服务平台",
      clearance: "海运服务",
      bulk: "一带一路特色服务",
      warehousing: "拼箱服务",
      cargo: "增值服务",
      project: "",
      port: "大港口",
      airports: "大国际机场",
      regions: "国家地区",
      covered: "覆盖行业",
      about: "关于我们",
      logistic: "多联式，一站式",
      about_title: "海贸国际隶属于香港吉葡集团（GP GROUP），是集外贸综合服务、物流服务、增值服务于一体的一站式外贸综合服务平台。",
      about_text: "依托二十余年成功经验与资源沉淀，我们为中小微企业提供“通关、收汇、退税、信保、物流”全链路基础服务，全程快捷且安全，高效解决外贸流程痛点。我们以“贸通天下 链接全球”为使命，坚守“客户第一，价值共创”的经营理念，深度聚焦电子产品、化工、航空、电力、汽车、机械设备六大核心领域，为国内外客户定制专属一站式贸易解决方案，助力客户实现价值最大化。",
      choose: "选择我们你能获得",
      solutions: "定制方案",
      solutions_text: "充分理解客户物流需求，一对一量身定制最合理的物流方案，帮你省时省力。",
      price: "价格透明",
      price_text: "费用合理清晰透明，拒绝虚假高价。有效为客户降低20%的物流成本，少花冤枉钱。",
      industrial: "深耕行业",
      industrial_text: "多年的货代经验，我们深知不同行业在货物运输、商业模式上的痛点与差异，并通过专业能力给客户带来最佳的体验。",
      others_title: "听听客户怎么说",
      others_subTitle: "收获好评率99.99%",
      others_text: "",
      evaArr: [
        { name: 'Akey', title: '宁波海贸是我们合作过的最好的货代公司之一。 他们的服务非常注重细节。无论是仓储、接收货物还是当地运输，他们都帮我们有效解决了。回复也很及时， 总之是一次非常愉快的合作！' },
        { name: 'Katherine', title: '合作的第五年了，非常满意。他们总能精准地把握我们的需求，并转化成省钱又便捷的物流方案。的的确确是为我们考虑的服务商！强烈推荐！' },
        { name: 'Michael', title: '服务到位，回复也很快。很庆幸当时在众多货代中选择了宁波海贸，看得出是老货代了。下次还会继续合作！' },
      ],
      partners: "我们的合作伙伴",
      from_title: "即刻联系我们",
      from_subTitle: "开启信任第一步",
      from_name: "姓名*",
      from_email: "邮箱*",
      from_loading: "起运港*",
      from_discharge: "目的港",
      from_cargo: "货物描述"
    },
    footer: {
      tel: "电话：",
      email: "邮箱：",
      service: "我们的服务",
      transport: "外贸综合服务平台",
      clearance: "海运服务",
      bulk: "一带一路特色服务",
      warehousing: "拼箱服务",
      cargo: "增值服务",
      project: "",
    },
    service: {
      banner: "快速响应-更优价格-合理方案",
      present: [
          {
          big_title: "外贸综合服务平台",
          big_subTitle: "",
          image1: "../../static/img/solu77.png",
          image2: "../../static/img/nav77.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s77.png",
          text: "",
          ocean: [
            {
              arr: [
                "为中小微企业提供快捷安全的“通关、收汇、退税、信保、物流”等一站式外贸基础服务",
                "通关：具备优质海关资质，享受绿色通关、快速查验、高效通过",
                "收汇：与境内外商业银行合作，帮助客户完成出口收汇、国际结算，并提供远期结售汇服务",
                "退税：帮助快速合规办理退税，安全顺畅",
                "清关：办理目的国海关申报、查验、征税、放行等手续，实现货物快速流通",
                "信保：与中国人保财险深度合作，为一般性贸易风险提供信用保障，帮助企业抢占订单、严控风险",
                "市场采购: 接受客户委托，通过市场采购贸易方式（海关代码1039），提供报检、报关、收汇等出口代理服务",
              ]
            },
          ]
        },
        {
          big_title: "海运服务",
          big_subTitle: "",
          image1: "../../static/img/solu11.png",
          image2: "../../static/img/nav11.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s11.png",
          text: "",
          ocean: [
            {
              arr: [
                "1.&nbsp   覆盖全球市场的进出口全方位服务",
                "2.&nbsp   提供多途径、多样化的服务选择"
              ]
            },
          ]
        },
        {
          big_title: "一带一路特色服务",
          big_subTitle: "",
          image1: "../../static/img/solu22.png",
          image2: "../../static/img/nav22.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s22.png",
          text: "",
          ocean: [
            {
              arr: [
                "国际铁路班列服务",
                "1.&nbsp  针对“一带一路”沿线国家进出口贸易需求，整合“新丝绸之路”沿线国家的物流资源",
                "2.&nbsp  提供到欧洲、中亚、俄罗斯等国家的门到门一站式物流服务",
                "国际公路运输服务",
                "1.&nbsp  提供中亚、俄罗斯、欧洲的整车门到门运输",
                "2.&nbsp  阿拉木图、塔什干、比什凯克、莫斯科的拼车专线",
                "3.&nbsp  每周稳定发车，目的地全境派送",
                "4.&nbsp  普货、化工品、危险品、超大件皆可",
              ]
            },
          ]
        },
        {
          big_title: "拼箱服务",
          big_subTitle: "",
          image1: "../../static/img/solu55.png",
          image2: "../../static/img/nav55.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s55.png",
          text: "",
          ocean: [
            {
              title: '',
              arr: [
                "空运服务",
                "1.&nbsp  专业空运操作团队，提供个性化解决方案",
                "2.&nbsp  与主要航空公司密切的合作关系，提供专属空运服务",
                "3.&nbsp  标注化服务，包租或分组，集运服务等多样化选择",
                "海运拼箱服务",
                "1.&nbsp  以覆盖全球的拼箱服务为核心",
                "2.&nbsp  提供长期仓储服务",
                "3.&nbsp  为客户提供综合性物流解决方案和增值服务",
                "专线服务",
                "1.&nbsp  提供欧美、中东、澳洲、俄罗斯的散货专线运输服务",
                "2.&nbsp  灵活多样化的物流管理方式和诚信的客户服务承诺",
              ]
            },
          ]
        },
        {
          big_title: "增值服务",
          big_subTitle: "",
          image1: "../../static/img/solu33.png",
          image2: "../../static/img/nav33.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s33.png",
          text: "",
          ocean: [
            {
              title: '',
              arr: [
                "1.&nbsp  国际逾期账款管理：为企业提供国际商业账款管理服务。我们的服务网络遍布全球，无论您的债务人身在何处，我们都将为您量身定做最优的账款解决方案，在维护您与客户合作关系的基础上，采取灵活多变的方式，助您最大化回收账款，改善现金流",
                "2.&nbsp  转口运输： 专注解决出口反倾销难题， 助您突破贸易壁垒限制，为中国出口企业提供一站式贸易壁垒解决方案",
                "3.&nbsp  金融服务： 为平台用户提供信用方式出口退税融资、赊销融资、信用融通、远期外汇等产品服务，免抵押 免担保 高周转 易操作，减轻企业垫资压力。",
              ]
            },
          ]
        }
      ],
      choose: "选择我们你能获得",
      choose_for: [
        {
          title: "定制服务",
          text: "充分理解客户物流需求，一对一量身定制最合理的物流方案，帮客户省时省力。"
        },
        {
          title: "价格透明",
          text: "费用合理清晰透明，拒绝虚假高价。有效为客户降低20%的物流成本，少花冤枉钱。"
        },
        {
          title: "深耕行业",
          text: "多年的货代经验，我们深知不同行业在货物运输、商业模式上的痛点与差异，并通过专业能力给客户带来最佳的体验。"
        },
      ],
      partners: "我们的合作伙伴",
      from_title: "即刻联系我们",
      from_subTitle: "开启信任第一步",
      from_name: "姓名*",
      from_email: "邮箱*",
      from_loading: "起运港*",
      from_discharge: "目的港",
      from_cargo: "货物描述"
    },
    company: {
      banner: "启于宁波，链接全球",
      summarize: "海贸，不仅仅是海贸",
      summarize_text: [
        "海贸国际隶属于香港吉葡集团（GP GROUP），是集外贸综合服务、物流服务、增值服务于一体的一站式外贸综合服务平台。依托二十余年成功经验与资源沉淀，我们为中小微企业提供“通关、收汇、退税、信保、物流”全链路基础服务，全程快捷且安全，高效解决外贸流程痛点。我们以“贸通天下 链接全球”为使命，坚守“客户第一，价值共创”的经营理念，深度聚焦电子产品、化工、航空、电力、汽车、机械设备六大核心领域，为国内外客户定制专属一站式贸易解决方案，助力客户实现价值最大化。"
      ],
      experience: "年行业经验",
      countries: "国家地区",
      industries: "覆盖行业",
      qualified: "我们的资质",
      core: "我们的核心凝聚力",
      culture: {
        title: "我们孜孜不倦地为客户提供卓越的服务，凝聚我们的团队成员，并为社会带来切实的改变。我们的目标是成为创新的问题解决者和以客户为中心的务实服务者。我们竭尽所能来满足您的需求。",
        arr: [
          "1. &nbsp 客户满意度是永恒的追求",
          "2. &nbsp 保持开放的姿态，时刻创意进取",
          "3. &nbsp 勤耕当下，放眼明天"
        ]
      },
      join: "欢迎加入我们",
      text: "如果你也认同我们的理念，如果你也在货代领域摸索多年，期望有一个团队与你共同奋斗。那么赶紧来加入宁波海贸大家庭吧！发你的简历到下方邮箱，让我们进一步认识你！",
      copy: "复制"
    },
    contant: {
      banner: "好的合作从建立信任开始",
      contants: "快速取得联系",
      tel: "电话：",
      email: "邮箱：",
      demands: "告诉我们你的需求",
      from_name: "姓名*",
      from_email: "邮箱*",
      from_loading: "起运港*",
      from_discharge: "目的港",
      from_cargo: "货物描述"
    }
  },

  en: {
    head: {
      home: "Home",
      service: "Service",
      transport: "Global Transport",
      clearance: "Customs Clearance",
      bulk: "Bulk Assembly",
      warehousing: "Warehousing",
      cargo: "Special Cargo Transport",
      project: "Project Logestics",
      about: "About",
      contant: "Contact"
    },
    home: {
      title: "Efficient Fast Thorough",
      subTitle: "Professional Global Logistics ",


      subTitle2: "Freight Forwarder Integrated Solutions",
      stop: "One-stop Industry-Leading Services",
      team: "Professional Team, Reasonable Price",
      more: "more",
      us: "learn more",
      transport: "Global Transport",
      clearance: "Customs Clearance",
      bulk: "Bulk Assembly",
      warehousing: "Warehousing",
      cargo: "Special Cargo Transport",
      project: "Project Logestics",
      port: "10 Important Ports",
      airports: "8 International Airports",
      regions: "200+ Countries & Regions",
      covered: "100+ Covered Industries",
      about: "About Us",
      logistic: "For One-stop Logistic Solutions",
      about_title: "Ningbo Hitrans Supply Chain Management Co., Ltd. is an international freight company integrating international sea, land and air transportation, customs declaration and customs clearance agency, etc.",
      about_text: "We have a professional international logistics team and have established a nationwide freight service network. For years, we have been committed to providing customers with one-stop international logistics solutions, promising high service, high quality and high standards.",
      choose: "Choose Us And You Will Get",
      solutions: "Customized Solutions",
      solutions_text: "We well understand the key demands of our customers, and provide with the most suitable logistic solutions that can both save cost and time.",
      price: "Price Transparency",
      price_text: "We refuse false high fees and make our fees clear and reasonable. We are able to reduce customers' logistic costs by 20%.",
      industrial: "Industrial Experience",
      industrial_text: "With years of logistics experience, we cleary understand the difference in cargo transportation and business models of each industry. We are willing to bring the best experience through our professional capabilities.",
      others_title: "Listen To What Others Say",
      others_subTitle: "Got 99.99% Praise Rate From Customers",
      others_text: " ",

      evaArr: [
        { name: 'Akey', title: '宁波海贸是我们合作过的最好的货代公司之一。 他们的服务非常注重细节。无论是仓储、接收货物还是当地运输，他们都帮我们有效解决了。回复也很及时， 总之是一次非常愉快的合作！' },
        { name: 'Katherine', title: '合作的第五年了，非常满意。他们总能精准地把握我们的需求，并转化成省钱又便捷的物流方案。的的确确是为我们考虑的服务商！强烈推荐！' },
        { name: 'Michael', title: '服务到位，回复也很快。   很庆幸当时在众多货代中选择了宁波海贸，看得出是老货代了。下次还会继续合作！' },
      ],
      partners: "Our Trusted Cooperative Partners",
      from_title: "Contact Us Right Now",
      from_subTitle: "Everything starts from trust",
      from_name: "Name",
      from_email: "Email",
      from_loading: "Port of Loading",
      from_discharge: "Port of Discharge",
      from_cargo: "Cargo Description"
    },
    footer: {
      tel: "Tel：",
      email: "Email：",
      service: "Our Services",
      transport: "Global Transport",
      clearance: "Customs Clearance",
      bulk: "Bulk Assembly",
      warehousing: "Warehousing",
      cargo: "Special Cargo Transport",
      project: "Project Logestics",
    },
    service: {
      banner: "Quick Response Reasonable Price Best Solution",
      present: [
        {
          big_title: "Global Transport",
          big_subTitle: "海运服务",
          image1: "../../static/img/solu1.jpg",
          image2: "../../static/img/nav1.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s1.png",
          text: "Ocean Freight:Covering the world's major routes, providing a full range of import and export services",
          ocean: [
            {
              title: 'Ocean Freight:',
              arr: [
                "1. Covering the world's major routes, providing a full range of import and export services",
                "2. Maintain a good cooperative relationship with the world's major ocean carriers and provide multi-channel and diversified service options"
              ]
            },
            {
              title: 'Land Forwarding:',
              arr: [
                "1. Provide factory delivery service in several major markets",
                "2. Provide short-distance, cross-port area and long-distance land transportation services",
                "3. Provide truck urgent dispatch service",
                "4. Provides single driver service or driver group service"
              ]
            },
            {
              title: 'Air Freight:',
              arr: [
                "1. Professional air cargo operation team to provide customized solutions",
                "2. Maintain close cooperation with major airlines and provide professional management",
                "3. Various options such as labeling services, chartering or grouping, and consolidation services"
              ]
            },
          ]
        },
        {
          big_title: "Customs Clearance",
          big_subTitle: "国际铁路班列服务",
          image1: "../../static/img/solu2.jpg",
          image2: "../../static/img/nav2.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s2.png",
          text: "Provide import and export customs clearance services",
          ocean: [
            {
              title: '',
              arr: [
                "1. Provide import and export customs clearance services",
                "2. US Import Security Filing (ISF)",
                "3. Pay customs duties",
                "4. USA/Canada automatic manifest declaration (AMS/E-MANIFEST)",
              ]
            },
          ]
        },
        {
          big_title: "Bulk Assembly",
          big_subTitle: "国际公路运输服务",
          image1: "../../static/img/solu3.jpg",
          image2: "../../static/img/nav3.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s3.png",
          text: "Provide short-term storage, long-term storage, etc. through supplier management",
          ocean: [
            {
              title: '',
              arr: [
                "1. Provide short-term storage, long-term storage, etc. through supplier management",
                "2. Accurate warehouse management system to optimize the packing scheme",
                "3. Provide purchase order management, booking coordination, carrier assignment and progress reporting",
              ]
            },
          ]
        },
        {
          big_title: "Warehousing",
          big_subTitle: "空运服务",
          image1: "../../static/img/solu4.jpg",
          image2: "../../static/img/nav4.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s4.png",
          text: "Multi-functional warehouses in major global airline markets",
          ocean: [
            {
              title: '',
              arr: [
                "1. Multi-functional warehouses in major global airline markets",
                "2. Differentiated processes, refined operation, and more value-added warehousing services",
                "3. Advanced and efficient warehouse management system",
              ]
            },
          ]
        },
        {
          big_title: "Special Cargo Transport",
          big_subTitle: "海运拼箱服务",
          image1: "../../static/img/solu5.jpg",
          image2: "../../static/img/nav5.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s5.png",
          text: "We provide flexible and diverse logistics management methods and have rich experience in the export and transportation of special goods. We can deliver:",
          ocean: [
            {
              title: 'We provide flexible and diverse logistics management methods and have rich experience in the export and transportation of special goods. We can deliver:',
              arr: [
                "1. Freezer",
                "2. Flat cabinet",
                "3. Open top cabinet",
                "4. Tank containers",
                "5. Hanging suitcase",
              ]
            },
          ]
        },
        {
          big_title: "Project Logestics",
          big_subTitle: "专线运输",
          image1: "../../static/img/solu6.jpg",
          image2: "../../static/img/nav6.png",
          image3: "../../static/img/service/service.png",
          img4: "../../static/img/service/s6.png",
          text: "We have rich experience in operation and management of turnkey contract logistics projects, and provide you with the best transportation solutions through world-leading technical resources and perfect logistics services.",
          ocean: [
            {
              title: 'We have rich experience in operation and management of turnkey contract logistics projects, and provide you with the best transportation solutions through world-leading technical resources and perfect logistics services.',
              arr: [
                "1. Ro-Ro equipment and services",
                "2. Standard, non-standard and bulk cargo services",
                "3. On-site packing of large and sensitive goods",
                "4. Heavy machinery disassembly",
                "5. Oversized cargo handling",
              ]
            },
          ]
        },
      ],
      choose: "Choose Us And You Will Get",
      choose_for: [
        {
          title: "Customized Solutions",
          text: "We well understand the key demands of our customers, and provide with the most suitable logistic solutions that can both save cost and time."
        },
        {
          title: "Price Transparency",
          text: "We refuse false high fees and make our fees clear and reasonable. We are able to reduce customers' logistic costs by 20%."
        },
        {
          title: "Industrial Experience",
          text: "With years of logistics experience, we cleary understand the difference in cargo transportation and business models of each industry. We are willing to bring the best experience through our professional capabilities."
        },
      ],
      partners: "Our Trusted Cooperative Partners",
      from_title: "Contact Us Right Now",
      from_subTitle: "Everything starts from trust",
      from_name: "Name",
      from_email: "Email",
      from_loading: "Start Port*",
      from_discharge: "End Port",
      from_cargo: "Cargo description"
    },
    company: {
      banner: "Start From Ningbo,Access To Whole World",
      summarize: "Hitrans, Transport For All Aspects",
      summarize_text: [
        "Welcome to Hitrans. ",
        '"Hi" in Chinese, has the same pronunciation of "Hai", meaning "sea", which shows our company‘s vast inclusiveness. We have been committed to expanding new transportation methods to both domestic and foreign networks. Our logistics network covers Shanghai, Ningbo, Shenzhen, Xiamen and other important ports, and our agency network covers Europe, the Mediterranean, USA, Canada, Japan, South Korea, the Middle East, Southeast Asia, Australia, etc., gradually forming a global logistics service network.',
        "So far, we have maintained close cooperation with many famous shipping companies including MAERSK, MSC, COSCO SHIPPING LINE, CMA-CGM, YANGMING, and also maintained good cooperation with global airlines such as OZ, TP, 6R, ET, AV, AM, CX.",
        "Apart from outside network, we also understand the importance of inner strength. We require each of our team members to keep professional and always improve service abilities. Our core members have an average of more than 10 years of freight forwarding experience. We believe that through an efficient and comprehensive service model and a unique understanding of the market, we can help more companies save costs and make profits efficiently."
      ],
      experience: "10+Years Experience",
      countries: "200+ Countries & Regions",
      industries: "100+ Covered Industries",
      qualified: "We Are Qualified",
      core: "Our Core Strength Lies Here",
      culture: {
        title: "We've worked tirelessly to serve customers like you with excellence, take care of our team members, and make a difference in our community. Our goal is to be innovative problem-solvers and great stewards of our client-centric culture. We use every tool in our box to ensure we meet your needs.",
        arr: []
      },
      join: "Welcome To Join Us",
      text: "If you share the same concept with us, if you also fight in the field of freight forwarding for many years, and long for a team to fight with you. It is time to join Ningbo Hitrans! Send your resume and let us know more about you!",
      copy: "copy"
    },
    contant: {
      banner: "A Good Start Begins With Trust.",
      contants: "Welcome To Contact",
      tel: "Tel:",
      email: "Email:",
      demands: "Tell Us Your Demands",
      from_name: "Name",
      from_email: "Email",
      from_loading: "Port of Loading",
      from_discharge: "Port of Discharge",
      from_cargo: "Cargo description"
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./static/data/text.js
// module id = null
// module chunks = 